var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCheck = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F7AE9674-164B-4F08-8EB3-2990E92FACAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.02-Onboarding",
    transform: "translate(-308.000000, -127.000000)",
    fill: "#E60000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown",
    transform: "translate(136.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Check",
    transform: "translate(172.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stroke",
    transform: "translate(2.749996, 4.583330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7018964,0.150727981 C15.8717841,-0.0369239012 16.1616272,-0.0513246265 16.3492791,0.118563061 C16.5160807,0.269574338 16.5459926,0.515365193 16.4312628,0.69991496 L16.381444,0.76594572 L5.59287678,12.6826124 C5.43115112,12.8612488 5.16376741,12.8810973 4.97856218,12.7421579 L4.9133292,12.6826124 L0.118563061,7.38648465 C-0.0513246265,7.19883277 -0.0369239012,6.90898968 0.150727981,6.739102 C0.317529654,6.58809072 0.565074997,6.58269004 0.737343346,6.71514814 L0.79811064,6.77126692 L5.25250352,11.6911702 L15.7018964,0.150727981 Z",
    id: "Shape"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_check.a934f20710b5c700a0c9f3706fc1d38e.svg";